export default __webpack_public_path__ + "static/media/20s_level_lost.93fcab03.mp3";